import axios from "axios";

import AuthService from "src/services/AuthService";
import jwtDecode from "jwt-decode";

const jwtInterceoptor = axios.create({});

jwtInterceoptor.interceptors.request.use(
  (config) => {
    let tokensData = JSON.parse(localStorage.getItem("tokens"));
    if (tokensData) {
      const token =
        config._isRefresh === true
          ? tokensData?.refreshToken
          : tokensData?.token;
      //const { exp } = jwtDecode(tokensData?.token);
      // const currentTime = Date.now() / 1000;

      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["ngrok-skip-browser-warning"] = "69420";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

jwtInterceoptor.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    if (error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        originalConfig._isRefresh = true;
        try {
          const authData = JSON.parse(localStorage.getItem("tokens"));

          let apiResponse = await AuthService.refreshToken(
            authData.refreshToken
          );
          localStorage.setItem("tokens", JSON.stringify(apiResponse.data));
          error.config.headers[
            "Authorization"
          ] = `Bearer ${apiResponse?.data.token}`;
          return axios(error.config);
        } catch (_error) {
          console.log(_error);
          localStorage.removeItem("tokens");
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }
          return Promise.reject(_error);
        }
      }
      if (error.response.status === 403 && error.response.data) {
        return Promise.reject(error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export default jwtInterceoptor;
